export function AudioWaveform() {
  return (
    <div className="flex items-end justify-center gap-[2px] h-4 mb-2">
      {[0, 1, 2, 3, 4, 5, 6].map((i) => (
        <div
          key={i}
          className="w-[2px] bg-[#1DB954]/70 rounded-full wave-bar"
          style={{
            animationDelay: `${i * 0.15}s`,
            height: '100%'
          }}
        />
      ))}
    </div>
  );
}
